export const ROUTES = {
    HOME: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    DASHBOARD: "/",
    PACKAGES: "/packages",
    EDIT_PROFILE: "/editprofile",
    RESULT: "/result",
    RESULT_NEW: "/resultnew",
    EXAM_SUMMARY: "/examsummary",
    QUIZ: "/quiz",
    QUIZ_RESULT: "/quizresult",
    LOADER: "/loader",
    
    // Legal Pages
    PRIVACY_POLICY: "/privacypolicy",
    TERMS_CONDITIONS: "/termsconditions",
    REFUND_POLICY: "/refundpolicy",
    CONTACT_US: "/contactus"
} as const;
